import { EffectsModule } from "@ngrx/effects";
import { MatIconModule } from "@angular/material/icon";
import { TranslocoModule } from "@jsverse/transloco";
import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { DetailsComponent } from "./details.component";
import { MatButtonModule } from "@angular/material/button";
import { StoreModule } from "@ngrx/store";
import * as fromSubscriptionDetailsStore from "./store/reducer";
import { SubscriptionDetailsEffects } from "./store";
import { VuiModule } from "@vui";
import { MatProgressBarModule } from "@angular/material/progress-bar";
import { MatDividerModule } from "@angular/material/divider";
import { RouterModule } from "@angular/router";
import { ReactiveFormsModule } from "@angular/forms";
import { MatCardModule } from "@angular/material/card";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatSelectModule } from "@angular/material/select";
import { MatInputModule } from "@angular/material/input";
import { MatRadioModule } from "@angular/material/radio";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatSidenavModule } from "@angular/material/sidenav";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { CreditCardEditorModule } from "libs/ui/credit-card-editor/src";
import { AddressEditorModule } from "@ui/address-editor";
import { TranslocoCoreModule } from "@i18n";
import { IMaskModule } from "angular-imask";
import { FuseCardModule, FuseScrollbarModule } from "@nx-workspace/fuse";
import { AbandonCancellationComponent } from "./abandon-cancellation/abandon-cancellation.component";

@NgModule({
    declarations: [DetailsComponent, AbandonCancellationComponent],
    imports: [
        CommonModule,

        MatIconModule,
        MatButtonModule,
        MatProgressBarModule,
        MatDividerModule,

        TranslocoModule,
        VuiModule,

        CommonModule,
        RouterModule,
        ReactiveFormsModule,
        MatCardModule,
        MatDividerModule,
        MatButtonModule,
        MatProgressBarModule,
        MatProgressSpinnerModule,
        MatSelectModule,
        MatIconModule,
        MatInputModule,
        MatRadioModule,
        MatExpansionModule,
        MatSidenavModule,
        MatCheckboxModule,
        CreditCardEditorModule,
        AddressEditorModule,
        TranslocoCoreModule,
        VuiModule,
        IMaskModule,
        FuseCardModule,
        FuseScrollbarModule,

        StoreModule.forFeature(
            fromSubscriptionDetailsStore.SUBSCRIPTION_DETAILS_FEATURE_KEY,
            fromSubscriptionDetailsStore.subscriptionDetailsReducer
        ),

        EffectsModule.forFeature([SubscriptionDetailsEffects]),
    ],
})
export class DetailsModule {}
